<template>
  <page-status class="order-pay" :loading="loading">
    <page-result :image="imgError" title="提示" desc="请重新尝试">
      <div class="reload-action">
        <van-button block type="info" @click="onReload">请重试</van-button>
      </div>
    </page-result>
  </page-status>
</template>

<script>
import * as qs from 'qs';

import PageStatus from '@/components/PageStatus';
import PageResult from '@/components/PageResult';
import imgError from '@/assets/img-status-error.png';
import * as constants from '@/utils/constants';
import * as services from '@/services';

const myWindow = window;

export default {
  name: 'WechatPay',
  components: {
    PageStatus,
    PageResult,
  },

  data() {
    return {
      loading: true,
      imgError,
    };
  },

  created() {
    this.handleWechatCertificate();
  },

  methods: {
    onReload() {
      // const { orderNo, platform } = this.$route.query;
      // const location = window.location;
      // const search = qs.stringify({ orderNo, platform });
      // const url = `${location.origin}${location.pathname}`;
      // window.location.replace([url, search].join('?'));
    },

    handleWechatCertificate() {
      // const { applyno, openid } = this.$route.query;
      // const isWxApplet = '1';
      // services
      //   .orderCertificate(applyno, openid, isWxApplet)
      //   .then(res => {
      //     window.location.replace(res.data);
      //   })
      //   .catch(res => (this.loading = false));
      const { orderNo, openid } = this.$route.query;
      const isWxApplet = '1';
      const search = qs.stringify({ applyno: orderNo, openid, isWxApplet });
      const host = window.location.host;

      if (host === 'test-motor.cathay-ins.com.cn') {
        this.loading = false;
        const url =
          'https://sit-zfpt.cathay-ins.com.cn/bp-paystation/weixinCertificateCountry.do';
        const obj = [url, search].join('?');
        window.location.replace(obj);
      } else {
        this.loading = false;
        const url =
          'https://zfpt.cathay-ins.com.cn/bp-paystation/weixinCertificateCountry.do';
        const obj = [url, search].join('?');
        window.location.replace(obj);
      }
    },
  },
};
</script>

<style lang="less">
.order-pay {
  height: 100%;

  .reload-action {
    margin: 12px 16px;
  }
}
</style>
